import React, { FC } from 'react';
import { HamburgerMenuItem } from './HamburgerMenu';
import { HamburgerMenuLink } from './HamburgerMenuLink';
import * as Contentful from 'contentful';

export interface HamburgerMenuLinksProps {
  menu: HamburgerMenuItem[];
  onMenuItemTap: () => void;
  indented?: boolean;
  logoutText?: string;
  playKitsByAgeLinks?: Contentful.Entry<Record<string, any>>[];
  playKitsDropdownLinks?: Contentful.Entry<Record<string, any>>[];
  shopAllPrimaryLinks?: Contentful.Entry<Record<string, any>>[];
  shopAllAdditionalLinks?: Contentful.Entry<Record<string, any>>[];
}

const HamburgerMenuLinks: FC<HamburgerMenuLinksProps> = ({
  menu,
  onMenuItemTap,
  indented = false,
  logoutText,
  playKitsByAgeLinks,
  playKitsDropdownLinks,
  shopAllPrimaryLinks,
  shopAllAdditionalLinks,
}) => {
  return (
    <>
      {menu.map((menuItem, index) => {
        return (
          <HamburgerMenuLink
            key={index}
            {...{
              menuItem,
              onMenuItemTap,
              indented,
              logoutText,
              playKitsByAgeLinks,
              playKitsDropdownLinks,
              shopAllPrimaryLinks,
              shopAllAdditionalLinks,
            }}
          />
        );
      })}
    </>
  );
};

export default React.memo(HamburgerMenuLinks);
